import { QueryDispatcher } from "../../shared/domain/QueryDispatcher";
import { v4 as uuidv4 } from 'uuid';

export class ReceiverDocsUsersQuery {
  constructor(
    private readonly dispatcher: QueryDispatcher,
  ) {}

 async run(): Promise<{ [key: string]: string; }> {
    const uuid = uuidv4()
    let args = {}
    return await this.dispatcher.dispatch('receiver.docs.users', args)
  }
}